import React from 'react'
import SoftButton from '../../common/SoftButton'
import { MagnifyingGlass } from '@phosphor-icons/react'

const SearchButton = ({ 
  onClick,
 }) => {

  return (
    <div className="relative flex items-center py-2.5 justify-between text-secondary gap-x-4" aria-label='Search' onClick={onClick}>
      <MagnifyingGlass className='menu-icons cursor-pointer text-black' weight="light" />
    </div>
  );
}

export default SearchButton